

/* @ngInject */ 
export default function AuthModalBody($templateCache) {
	var templateString = $templateCache.get('templates/auth-modal/auth-modal-body-tmpl.html');

	return {
		restrict: 'E',
		scope: {
			test: '='
		},
		transclude: true,
		link: AuthModalBodyLink,
		template: templateString
	};
}

function AuthModalBodyLink() {}
